export default "__VITE_ASSET__UFdvtMYs__"